import React, { Component } from 'react';
import { Card, Table, Form, Radio, Tree, Button, Input, Menu, Icon, Dropdown, Modal, message as Message, Divider } from 'antd';
import common from '../../assets/common.js';
import './area.css';
const TreeNode = Tree.TreeNode;
const FormItem = Form.Item;
const confirm = Modal.confirm;

class CanteenListView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalConfig: {
                visible: false,
                title: '添加区域',
                input: '区域',
                name: false,
                initialValue: '',
                doorName: '',
                onOk: async () => {
                    this.props.form.validateFields((err, values) => {
                        if (!err) {
                            // console.log('Received values of form: ', values);
                            this.handleArea('add', values)
                        }
                    });
                },
                onCancel: this.closeModal
            },
            tree: {
                expandedKeys: [],
                onSelect: this.onTreeSelect,
                onExpand: this.onTreeExpand,
                // defaultExpandedKeys: ["buildingId66"],
                selectedKeys: [],
                dataSource: []
            },
            treeNode: '',
            key: '',
            roomId: '',
            info: null,
            selectedTreeItem: null,
            table: {
                scroll: { x: true },
                loading: false,
                rowKey: 'id',
                dataSource: [],
                columns: [{
                  title: '设备编号',
                  dataIndex: 'snNumber'
                }, {
                  title: '所在位置',
                  dataIndex: 'doorName',
                }, {
                  title: '设备方向',
                  width: '100px',
                  render: (text, record) => {
                    return (
                      <span>{record.direct === "IN"?"进":"出"}</span>
                    )
                  }
                },{
                  title: '最后在线时间',
                  render: (text, record) => {
                    return (
                      <span>{record.lastLineTime?common.strToTime(record.lastLineTime):'未上线'}</span>
                    )
                  }
                }, {
                  title: '是否有效',
                  width: '100px',
                  render: (text, record) => {
                    return (
                      <span>{record.status === "VALID"?'有效':'无效'}</span>
                    )
                  }
                }, {
                    title: '操作',
                    key: 'action',
                    width: '160px',
                    render: (text, record) => {
                        return (
                          <div>
                            <a className="a-theme" onClick={() => this.showModalDevice(record)}>修改</a>
                            <Divider type="vertical"/>
                            <a className="a-theme" onClick={() => this.enable(record)}>{record.status === "VALID"?'禁用':'启用'}</a>
                            <Divider type="vertical"/>
                            <a className="a-theme" onClick={() => this.deleteDevice('del', record)}>删除</a>
                          </div>
                        )
                    }
                }],
                pagination: {
                    current: 1,
                    total: 0,
                    pageSize: 10,
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    showSizeChanger: true,
                },
                onChange: this.onTableChange
            },
            arr: [{name:"区域",value:"area"},{name:"楼栋",value:"build"},{name:"楼门",value:"room"},{name:"设备",value:"device"}]
        }
    }

    componentDidMount() {
      let this_ = this;
      if(window.localStorage.getItem("roomId")) {
        let roomId = window.localStorage.getItem("roomId");
        let info = window.localStorage.getItem("info");
        this_.setState({
          roomId,
          info
        },() => {
            this_.getTreeData();
            setTimeout(() => {
              window.localStorage.clear("roomId");
            },500)
        })
      } else {
        this_.getTreeData();
      }
    }

    init = () => {

    }

    getTreeData = () => {
      var postData = {};
      var roomId = this.state.roomId;
      postData["_url"] = "api/dc/access/area";
      postData["_method"] = "GET";
      common.request(postData, this, function(obj, result){
        let dataSource = [result.result]
        let tree = obj.state.tree
        Object.assign(tree, {
            dataSource,
            selectedKeys: roomId !== ''?["roomId" + roomId]:['rootId'],
            expandedKeys: roomId !== ''?["roomId" + roomId]:['rootId'],
            defaultExpandedKeys: roomId !== ''?["roomId" + roomId]:['rootId'],
            defaultSelectedKeys: roomId !== ''?["roomId" + roomId]:['rootId']
        })
        obj.setState({
            tree,
            treeNode: obj.getTreeNode(dataSource),
            selectedTreeItem: dataSource[0]
        }, obj.search)
      });
    }
    onTreeSelect = (selectedKeys, { selectedNodes, selected }) => {
        // console.log(selectedNodes);
        if (selected) {
            let { tree, table } = this.state
            table.pagination.current = 1
            Object.assign(tree, {
                selectedKeys: selectedKeys,
            })
            this.setState({
                tree,
                table,
                info: null,
                selectedTreeItem: selectedNodes[0].props.dataRef
            }, this.search)
        }
    }

    onTreeExpand = (expandedKeys, { expanded: bool, node }) => {
        let tree = this.state.tree
        Object.assign(tree, {
            expandedKeys: expandedKeys,
        })
        this.setState({
            tree,
        })
    }

    getTreeNode = (data, parent) => {
        return data.map((item) => {
            if (!parent) {
                item.deep = 1
            } else {
                item.deep = parent.deep + 1
            }
            item.title = <div title={item.rootName} style={{ display: "flex" }}>
                <span style={{ flex: 1, overflow: 'hidden' }}>{item.rootName?item.rootName:(item.areaName?item.areaName:(item.building?item.building:item.roomName))}</span>
                <span className="tree-ex" onClick={e => e.stopPropagation()}>
                    {
                        (() => {

                            return <Dropdown
                                getPopupContainer={() => document.getElementsByClassName("ant-tree ant-tree-icon-hide")[0]}
                                overlay={
                                    <Menu className="tree-popover">
                                        {item.deep === 1 && <Menu.Item key="2">
                                            <a onClick={() => this.showModal(item, "area")}>添加区域</a>
                                        </Menu.Item>}
                                        {item.deep === 2 && <Menu.Item key="3">
                                            <a onClick={() => this.showModal(item, "build")}>添加楼栋</a>
                                        </Menu.Item>}
                                        {item.deep === 3 && <Menu.Item key="4">
                                            <a onClick={() => this.showModal(item, "room")}>添加楼门</a>
                                        </Menu.Item>}
                                        {item.deep === 4 && <Menu.Item key="5">
                                            <a onClick={() => this.showModal(item, "device")}>添加设备</a>
                                        </Menu.Item>}
                                        {
                                            item.deep === 2 && <Menu.Item key="6">
                                                <a onClick={() => {
                                                    this.showModal(item, "build", true)
                                                }}>编辑</a>
                                            </Menu.Item>
                                        }
                                        {
                                            item.deep === 3 && <Menu.Item key="7">
                                                <a onClick={() => {
                                                    this.showModal(item, "room", true)
                                                }}>编辑</a>
                                            </Menu.Item>
                                        }
                                        {
                                            item.deep === 4 && <Menu.Item key="8">
                                                <a onClick={() => {
                                                    this.showModal(item, "device", true)
                                                }}>编辑</a>
                                            </Menu.Item>
                                        }
                                        {
                                            item.deep === 2 && <Menu.Item key="9">
                                                <a onClick={() => {
                                                    this.handleBuild('del', item)
                                                }}>删除</a>
                                            </Menu.Item>
                                        }
                                        {
                                            item.deep === 3 && <Menu.Item key="10">
                                                <a onClick={() => {
                                                    this.handleRoom('del', item)
                                                }}>删除</a>
                                            </Menu.Item>
                                        }
                                        {
                                            item.deep === 4 && <Menu.Item key="11">
                                                <a onClick={() => {
                                                    this.handleDevice('del', item)
                                                }}>删除</a>
                                            </Menu.Item>
                                        }
                                        {
                                            item.deep === 4 && <Menu.Item key="12">
                                                <a onClick={() => {
                                                    this.checkpass(item)
                                                }}>查看可通行人员</a>
                                            </Menu.Item>
                                        }
                                    </Menu>
                                } trigger={['click']}>
                                <Icon type="ellipsis" onClick={e => e.stopPropagation()} />
                            </Dropdown>
                        })()
                    }
                </span>
            </div>
            if (item.subList) {
              return (
                  <TreeNode id={'rootId'} title={item.title} key={"rootId"} dataRef={item}>
                      {this.getTreeNode(item.subList, item)}
                  </TreeNode>
              );
            } else if(item.dcBuildingList) {
              return (
                  <TreeNode id={item.areaId} title={item.title} key={"areaId" + item.areaId} dataRef={item}>
                      {this.getTreeNode(item.dcBuildingList, item)}
                  </TreeNode>
              );
            } else if(item.roomList){
              return (
                  <TreeNode id={item.buildingId} title={item.title} key={"buildingId" + item.buildingId} dataRef={item}>
                      {this.getTreeNode(item.roomList, item)}
                  </TreeNode>
              );
            }
            return <TreeNode id={item.roomId} {...item} title={item.title} key={"roomId" + item.roomId} dataRef={item} />;
        });
    }
    search = () => {
        const { selectedTreeItem, table, key, roomId } = this.state
        let { current: pageNum, pageSize } = table.pagination
        let params = { pageNum, pageSize, desc: 'id', deleted: 'false' }
        if (key) {
            params.key = key
        }
        if(window.localStorage.getItem("roomId")) {
          window.localStorage.clear("roomId");
          params.roomId = roomId;
        } else {
          if (selectedTreeItem.deep === 2) {
            params.areaId = selectedTreeItem.id
          } else if (selectedTreeItem.deep === 3) {
            params.buildingId = selectedTreeItem.id
          } else if (selectedTreeItem.deep === 4) {
            params.roomId = selectedTreeItem.id
          }
        }
        table.loading = true
        this.setState({
            table,
        })
        params["_url"] = "api/dc/device/search";
        common.request(params, this, function(obj, result){
          let list = result.result.list;
          let pageInfo = result.result.pageInfo;
          if (list && pageInfo) {
              table.pagination.current = pageInfo.pageNum
              table.pagination.pageSize = pageInfo.pageSize
              table.pagination.total = pageInfo.resultAmount
              table.dataSource = list
              table.loading = false
              obj.setState({
                  table
              })
          }
        });
    }

    onTableChange = (pagination, filters, sorter) => {
      let table = this.state.table
      table.pagination = pagination
      this.setState({
          table
      }, this.search)
    }

    closeModal = () => {
      let modalConfig = this.state.modalConfig
      modalConfig.visible = false
      this.setState({
        modalConfig
      })
    }
    showModal = (info, area, type) => {
      let modalConfig = this.state.modalConfig
      modalConfig.visible = true
      if(area === "area") {
        modalConfig.name = false;
        modalConfig.group = false;
        if(type) {

        } else {
          modalConfig.title = "添加区域";
          modalConfig.input = "区域名称";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      this.handleArea('add', values)
                  }
              });
          }
        }

      } else if(area === "build") {
        modalConfig.name = false;
        modalConfig.group = false;
        if(type) {
          modalConfig.initialValue = info.areaName;
          modalConfig.title = "修改区域";
          modalConfig.input = "区域名称";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      values["id"] = info.id;
                      this.handleArea('edit', values)
                  }
              });
          }

        } else {
          modalConfig.title = "添加楼栋";
          modalConfig.input = "楼栋名称";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      values["building"] = values["areaName"];
                      values["areaId"] = info.areaId;
                      delete values["areaName"];
                      this.handleBuild('add', values)
                  }
              });
          }
        }

      } else if(area === "room") {
        modalConfig.name = false;
        modalConfig.group = false;
        if(type) {
          modalConfig.initialValue = info.building;
          modalConfig.title = "修改楼栋";
          modalConfig.input = "楼栋名称";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      values["building"] = values["areaName"];
                      values["areaId"] = info.areaId;
                      delete values["areaName"];
                      values["id"] = info.id;
                      this.handleBuild('edit', values)
                  }
              });
          }
        } else {
          modalConfig.title = "添加楼门";
          modalConfig.input = "楼门名称";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      values["roomName"] = values["areaName"];
                      values["buildingId"] = info.buildingId;
                      delete values["areaName"];
                      this.handleRoom('add', values)
                  }
              });
          }
        }

      } else {
        if(type) {
          modalConfig.name = false;
          modalConfig.group = false;
          modalConfig.direct = false;
          modalConfig.initialValue = info.roomName;
          modalConfig.title = "修改楼门";
          modalConfig.input = "楼门名称";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      values["roomName"] = values["areaName"];
                      values["buildingId"] = info.buildingId;
                      delete values["areaName"];
                      values["id"] = info.id;
                      this.handleRoom('edit', values)
                  }
              });
          }
        } else {
          modalConfig.name = true;
          modalConfig.title = "添加设备";
          modalConfig.group = true;
          modalConfig.value = "VGUANG";
          modalConfig.direct = "IN";
          modalConfig.input = "设备编号";
          modalConfig.onOk = async () => {
              this.props.form.validateFields((err, values) => {
                  if (!err) {
                      // console.log('Received values of form: ', values);
                      values["snNumber"] = values["areaName"];
                      values["roomId"] = info.roomId;
                      delete values["areaName"];
                      this.handleDevice('add', values)
                  }
              });
          }
        }
      }
      this.setState({
          modalConfig,
          selectedTreeItem: info
      })
    }
    enable = (info) => {
      if(info.status === "VALID") {
        var postData = {};
        postData["_url"] = "api/dc/device/disable";
        postData["id"] = info.id;
        common.request(postData, this, function(obj, result){
          Message.success('禁用成功!')
          obj.closeModal();
          obj.search()
        });
      } else {
        var postData = {};
        postData["_url"] = "api/dc/device/enable";
        postData["id"] = info.id;
        common.request(postData, this, function(obj, result){
          Message.success('启用成功!')
          obj.closeModal();
          obj.search()
        });
      }
    }
    showModalDevice = (info) => {
      info.deep = this.state.selectedTreeItem.deep;
      let modalConfig = this.state.modalConfig
      modalConfig.visible = true
      modalConfig.name = true;
      modalConfig.group = true;
      modalConfig.initialValue = info.snNumber;
      modalConfig.doorName = info.doorName;
      modalConfig.title = "修改设备";
      modalConfig.value = info.deviceType;
      modalConfig.direct = 'IN';// info.direction;
      modalConfig.input = "设备编号";
      modalConfig.onOk = async () => {
          this.props.form.validateFields((err, values) => {
              if (!err) {
                  // console.log('Received values of form: ', values);
                  values["snNumber"] = values["areaName"];
                  delete values["areaName"];
                  values["id"] = info.id;
                  this.handleDevice('edit', values)
              }
          });
      }
      this.setState({
        modalConfig
      })
    }
    // exportExcel = () => {
    //     window.open(window.location.origin + "/qrpos/api/order/export");
    // }

    handleArea = (type, info) => {
        if (type === 'del') {
        } else if (type === 'add') {
          var postData = info;
          postData["_url"] = "api/dc/access/area";
          common.request(postData, this, function(obj, result){
            Message.success('添加成功!')
            obj.closeModal();
            obj.getTreeData()
          });
        } else if (type === 'edit') {
          var postData = info;
          postData["_url"] = "api/dc/access/area?id=" + info.id;
          postData["_method"] = "PUT";
          delete postData["id"];
          common.request(postData, this, function(obj, result){
            Message.success('修改成功!')
            obj.closeModal();
            obj.getTreeData()
          });
        }
    }

    handleBuild = (type, info) => {
        if (type === 'del') {
            confirm({
                content: '确认删除该区域?',
                centered: true,
                onOk: async () => {
                  var postData = {};
                  postData["_url"] = "api/dc/access/area";
                  postData["_method"] = "DELETE";
                  postData["id"] = info.id;
                  common.request(postData, this, function(obj, result){
                    Message.success('删除成功!')
                    obj.getTreeData()
                  });
                }
            })
        } else if (type === 'add') {
          var postData = info;
          postData["_url"] = "api/dc/building";
          common.request(postData, this, function(obj, result){
            Message.success('添加成功!')
            obj.closeModal();
            obj.getTreeData()
          });
        } else if (type === 'edit') {
          var postData = info;
          postData["_url"] = "api/dc/building?id="+ info.id;
          postData["_method"] = "PUT";
          delete postData["id"];
          common.request(postData, this, function(obj, result){
            Message.success('修改成功!')
            obj.closeModal();
            obj.getTreeData()
          });
        }
    }

    handleRoom = (type, info) => {
        if (type === 'del') {
            confirm({
                content: '确认删除该楼栋?',
                centered: true,
                onOk: async () => {
                  var postData = {};
                  postData["_url"] = "api/dc/building";
                  postData["_method"] = "DELETE";
                  postData["id"] = info.id;
                  common.request(postData, this, function(obj, result){
                    Message.success('删除成功!')
                    obj.getTreeData()
                  });
                }
            })
        } else if (type === 'add') {
          var postData = info;
          postData["_url"] = "api/dc/room";
          common.request(postData, this, function(obj, result){
            Message.success('添加成功!')
            obj.closeModal();
            obj.getTreeData()
          });
        } else if (type === 'edit') {
          var postData = info;
          postData["_url"] = "api/dc/room?id="+ info.id;
          postData["_method"] = "PUT";
          delete postData["id"];
          common.request(postData, this, function(obj, result){
            Message.success('修改成功!')
            obj.closeModal();
            obj.getTreeData()
          });
        }
    }

    handleDevice = (type, info) => {
        if (type === 'del') {
            confirm({
                content: '确认删除该楼门?',
                centered: true,
                onOk: async () => {
                  var postData = {};
                  postData["_url"] = "api/dc/room";
                  postData["_method"] = "DELETE";
                  postData["id"] = info.id;
                  common.request(postData, this, function(obj, result){
                    Message.success('删除成功!')
                    obj.getTreeData()
                  });
                }
            })
        } else if (type === 'add') {
          var postData = info;
          postData["_url"] = "api/dc/device";
          common.request(postData, this, function(obj, result){
            Message.success('添加成功!')
            obj.closeModal();
            obj.search()
          });
        } else if (type === 'edit') {
          var postData = info;
          postData["_url"] = "api/dc/device?id=" + info.id;;
          postData["_method"] = "PUT";
          delete postData["id"];
          common.request(postData, this, function(obj, result){
            Message.success('修改成功!')
            obj.closeModal();
            obj.search()
          });
        }
    }

    deleteDevice = (type, info) => {
      confirm({
          content: '确认删除该设备?',
          centered: true,
          onOk: async () => {
            var postData = {};
            postData["_url"] = "api/dc/device";
            postData["_method"] = "DELETE";
            postData["id"] = info.id;
            common.request(postData, this, function(obj, result){
              Message.success('删除成功!')
              obj.search()
            });
          }
      })
    }
    downloadOfflineQRCode = async (data) => {
        let params = {
            type: 'Window'
        }
        if (data.deep === 2) {
            params.canteen = data.id;
        }
        if (data.deep === 3) {
            params.canteen = data.pid;
            params.window = data.id;
        }
        let url = null;
        window.open(url)
    }
    // 查看可通行的人员
    checkpass = (info) => {
      window.localStorage.setItem('info', JSON.stringify(info));
      this.props.history.push("/manage/area/pass");
      window.localStorage.setItem('roomId', info.roomId);
    }
    render() {
        const { tree, table, modalConfig, arr, treeNode, info} = this.state;
        const formItemLayout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 18 },
        };
        let selectedTreeItem = this.state.selectedTreeItem;
        if(info !== null) {
          selectedTreeItem = JSON.parse(info);
        }
        // console.log(selectedTreeItem && selectedTreeItem.deep);
        let deep = 0;
        if(selectedTreeItem && selectedTreeItem.deep) {
          deep = selectedTreeItem.deep -1;
        }

        const { getFieldDecorator } = this.props.form;
        return <div className="canteen-list-page">
            <Card>
              { selectedTreeItem && selectedTreeItem.deep !== 0 && <Button className="mr-8" type="primary" onClick={()=> this.showModal(selectedTreeItem, arr[deep].value)}>添加{  arr[deep].name }</Button> }
              { selectedTreeItem && selectedTreeItem.deep > 1 && <Button className="mr-8" type="primary" onClick={()=> this.showModal(selectedTreeItem, arr[deep].value, true)}>编辑</Button> }
              { selectedTreeItem && selectedTreeItem.deep === 2 && <Button className="mr-8" onClick={()=> this.handleBuild('del', selectedTreeItem)}>删除</Button> }
              { selectedTreeItem && selectedTreeItem.deep === 3 && <Button className="mr-8" onClick={()=> this.handleRoom('del', selectedTreeItem)}>删除</Button> }
              { selectedTreeItem && selectedTreeItem.deep === 4 && <Button className="mr-8" onClick={()=> this.handleDevice('del', selectedTreeItem)}>删除</Button> }
              { selectedTreeItem && selectedTreeItem.deep === 4 && <Button className="mr-8" onClick={()=> this.checkpass(selectedTreeItem)}>查看可通行人员</Button> }
                <div className="body">
                    <div id="tree-wrap" className="tree-wrap">
                        <div className="title">门禁信息</div>
                        {treeNode !== '' && <Tree defaultExpandedKeys={['buildingId66']} {...tree}>
                            { treeNode }
                          </Tree>
                        }
                    </div>
                    <Table {...table} />
                </div>
            </Card>
            <Modal
                destroyOnClose={true}
                centered={true}
                {...modalConfig}>
                <Form>
                    {
                      modalConfig.group && <FormItem {...formItemLayout}
                          label="设备类型">
                          {getFieldDecorator('deviceType', {
                              rules: [{
                                  required: true, message: '请选择设备类型',
                              }],
                              initialValue: modalConfig.value
                          })(
                            <Radio.Group>
                              <Radio value="VGUANG">二维码扫码头</Radio>
                              <Radio value="UFACE">人脸设备</Radio>
                            </Radio.Group>
                          )}
                      </FormItem>
                    }
                    <FormItem {...formItemLayout}
                        label={modalConfig.input}>
                        {getFieldDecorator('areaName', {
                            rules: [{
                                required: true, message: '请填写' + modalConfig.input,
                            }],
                            initialValue: modalConfig.initialValue
                        })(
                            <Input />
                        )}
                    </FormItem>
                    {
                      modalConfig.name && <FormItem {...formItemLayout}
                          label="设备别名">
                          {getFieldDecorator('doorName', {
                              rules: [{
                                  required: true, message: '请填写设备别名',
                              }],
                              initialValue: modalConfig.doorName
                          })(
                              <Input />
                          )}
                      </FormItem>
                    }
                    {
                      modalConfig.direct && <FormItem {...formItemLayout}
                          label="设备方向">
                          {getFieldDecorator('direct', {
                              rules: [{
                                  required: true, message: '请选择设备方向',
                              }],
                              initialValue: modalConfig.direct
                          })(
                            <Radio.Group>
                              <Radio value="IN">进</Radio>
                              <Radio value="OUT">出</Radio>
                            </Radio.Group>
                          )}
                      </FormItem>
                    }
                </Form>
            </Modal>
        </div>
    }
}
const CanteenListViewForm = Form.create()(CanteenListView);
export default CanteenListViewForm;



// WEBPACK FOOTER //
// ./src/component/manage/area.js